import { useState, useEffect, KeyboardEventHandler } from 'react'
import { useLocation } from 'react-router-dom'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import { TooltipComponent, TooltipComponentMobile } from '../Tooltip'
import { MajorReactGAHandlers } from '../ReactGAHandlers'
import filterIcon from '../../../custom_assets/filter_icon.png'
import { collegeMap } from '../collegeMap'

const Aside = ({ collegeSet, colleges, collegesOptions, collegesOptionsFull, setShowRelatedMajors, results, setCollegeSelect, setCollegeSetSelect, setPublicSelect, setPrivateSelect, majorName, filtersActive, mobile = false, showRelatedMajors, keywordSelect, setKeywordSelect, keywordFilter, setKeywordFilter }) => {

  const location = useLocation()

  //////// Keyword ////////

  const [selectInput, setSelectInput] = useState('')

  const createOption = (label: string) => ({
    label: label,
    value: label,
  });

  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (!selectInput) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        setKeywordSelect((prev) => [...prev, createOption(selectInput)]);
        setSelectInput('');
        event.preventDefault();
    }
  };

  useEffect(() => {

    let params = new URLSearchParams(location.search);
    let keywordParam = params.get('keyword');

    if (keywordParam) {
      let keywords = keywordParam.split(',').map(res => ({ label: res, value: res }));
      setKeywordSelect(keywords)
    }

  }, [location.search]);

  const keywordSelectComponent = (
    <div className='mt-4 d-flex flex-column'>
      <div className='dca-aside-header'>KEYWORDS</div>
      <CreatableSelect
        components={{
          DropdownIndicator: null
        }}
        inputValue={selectInput}
        isClearable
        isMulti
        noOptionsMessage={() => "Start typing..."}
        onChange={(newValue) => setKeywordSelect(newValue || [])}
        onInputChange={(newValue) => setSelectInput(newValue)}
        onKeyDown={handleKeyDown}
        placeholder="Enter keyword(s)..."
        value={keywordSelect}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            border: 'transparent',
            backgroundColor: '#F9F9F9'
          })
        }}
      />
    </div>)

  //////// College ////////
  const [selectedColleges, setSelectedColleges] = useState<any>([])

  const handleCollegeSelectChange = (selectedColleges) => {
    setSelectedColleges(selectedColleges);
    let collegeArr: any = []
    selectedColleges.map((college) =>
      collegeArr.push(college.value))
    setCollegeSelect(collegeArr)
  }

  const collegeSelect = (
    <div className='mt-4 d-flex flex-column'>
      <div className='dca-aside-header'>COLLEGE</div>
      <Select
        options={collegesOptions}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            border: 'transparent',
            backgroundColor: '#F9F9F9'
          })
        }}
        isMulti
        value={selectedColleges}
        onChange={handleCollegeSelectChange}
      // onInputChange={(inputValue) => {
      //   handleInputNameChange(inputValue)
      // }}
      />
    </div>
  )

  useEffect(() => {
    let params = new URLSearchParams(location.search);
    let collegeNameParam = params.get('collegeName');

    if (collegeNameParam) {
      let res: any[] = []
      const names = collegeNameParam.split(',')

      names.map((val) => {
        let collegeObj: any = collegeMap?.find(obj => obj.hyphenated === val)?.id

        let matchingCollegeOpt: any = collegesOptions.find(col => col?.value == parseInt(collegeObj))
        if (matchingCollegeOpt) {
          res.push(matchingCollegeOpt)
        }
      })

      if (res.length > 0) {
        handleCollegeSelectChange(res)
      } else {
        setSelectedColleges([])
      }
    }
    else {
      setSelectedColleges([])
    }
  }, [location.search, collegesOptionsFull])

  //////// School Type ////////
  let publicCount: any = '-'
  let privateCount: any = '-'

  const [schoolTypeSelected, setSchoolTypeSelected] = useState<any>(0)

  const handleCheckChange = (event) => {
    let checkStatus = event.target.checked
    return checkStatus
  }

  if (results.length > 0 && colleges.length > 0) {
    let collegeIds: any = []
    results.map((res) => {
      collegeIds.push(res.college_id)
    })

    let collegeArr: any = []
    collegeIds.map((college) => {
      collegeArr.push(colleges.filter((item) => item.id == college))
    })

    publicCount = collegeArr.filter((item) => item[0].type === 1).length

    privateCount = collegeArr.filter((item) => ((item[0].type === 2) || (item[0].type === 3))).length
  }

  useEffect(() => {

    switch (true) {
      case schoolTypeSelected === 0:
        setPrivateSelect(false);
        setPublicSelect(false);
        break;
      case schoolTypeSelected === 1:
        setPrivateSelect(false);
        setPublicSelect(true);
        break;
      case schoolTypeSelected === 2:
        setPrivateSelect(true);
        setPublicSelect(false);
        break;
      default:
        setPrivateSelect(false);
        setPublicSelect(false);
        break;
    }
  }, [schoolTypeSelected])

  const schoolTypeSelect = (
    <div className='mt-4 d-flex flex-column' style={{ marginTop: '15px' }}>
      <div className='dca-aside-header'>INSTITUTION TYPE</div>
      <div className='d-flex flex-row justify-content-center align-items-center'>
        <button
          type="button"
          onClick={() => setSchoolTypeSelected(0)}
          className={`btn btn-sm ${schoolTypeSelected === 0 ? 'btn-success' : 'btn-light'}`}
          aria-pressed="true"
          style={{ width: '100%' }}
        >
          All
        </button>
        <button
          type="button"
          onClick={() => setSchoolTypeSelected(1)}
          className={`btn btn-sm ${schoolTypeSelected === 1 ? 'btn-success' : 'btn-light'}`}
          aria-pressed="true"
          style={{ width: '100%' }}
        >
          Public
        </button>
        <button
          type="button"
          onClick={() => setSchoolTypeSelected(2)}
          className={`btn btn-sm ${schoolTypeSelected === 2 ? 'btn-success' : 'btn-light'}`}
          aria-pressed="true"
          style={{ width: '100%' }}
        >
          Private
        </button>
      </div>
    </div>
  )

  //////// College Set ////////
  const [selectedSet, setSelectedSet] = useState<any>([])

  const handleCollegeSetSelectChange = (selectedSet) => {
    setSelectedSet(selectedSet);
    // if (selectedSet.length > 0) {
    //   let selected = selectedSet.flatMap(set => set.value);
    //   selected = [...new Set(selected)]
    //   // setCollegeSetSelect(selectedSet[0].value)
    //   setCollegeSetSelect(selected)
    // }
    // else {
    //   setCollegeSetSelect(selectedSet)
    // }
    setCollegeSetSelect(selectedSet)
  }

  const collegeSetSelect = (
    <div className='mt-4 d-flex flex-column' style={{ marginTop: '15px' }}>
      <div className='dca-aside-header'>COLLEGE SET</div>
      <Select
        options={collegeSet}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            border: 'transparent',
            backgroundColor: '#F9F9F9'
          })
        }}
        isMulti
        value={selectedSet}
        onChange={handleCollegeSetSelectChange}
      />
    </div>
  )

  useEffect(() => {
    let params = new URLSearchParams(location.search);
    let collegeSetParam = params.get('collegeSet');

    if (collegeSetParam) {
      let res: any[] = []
      collegeSetParam.split(',').map(val => {
        let collegeSetObj = collegeSet.find(obj => obj.label.toLowerCase().replace(/\s+/g, '+') == val)

        if (collegeSetObj) {
          res.push(collegeSetObj)
        }
      })

      if (res.length > 0) {
        handleCollegeSetSelectChange(res)
      }

      else {
        setSelectedSet([])
      }
    } else {
      setSelectedSet([])
    }
  }, [location.search, collegeSet])

  //////// Show Related Majors ////////

  const { handleGAEventShowRelated } = MajorReactGAHandlers()

  const handleClickActionsShowRelatedMajors = (event) => {
    try {
      setShowRelatedMajors(handleCheckChange(event))
    } catch (error) {
      throw error
    } finally {
      // Trigger handleGAEventShowRelated whenever it is checked true/active
      handleCheckChange(event) == true && handleGAEventShowRelated()
    }
  }

  // const showRelatedMajorsToggle = (
  //   <div style={{ marginTop: '15px' }}>
  //     <label className="checkbox d-flex justify-content-between" style={{ cursor: 'pointer' }}>
  //       <div>
  //         <input
  //           type="checkbox"
  //           className='dca-checkbox'
  //           name="Show Related Majors"
  //           onChange={(event) => {
  //             handleClickActionsShowRelatedMajors(event)
  //           }}
  //           style={{ cursor: 'pointer' }}
  //         />
  //         <span className='ms-3 me-3' style={{ display: 'inline-block' }}>Show Related Majors <span className='ms-1'><TooltipComponent content={`Select the checkbox to also display majors that are similar to ${majorName}.`} /></span></span>
  //       </div>
  //     </label>
  //   </div>
  // )

  const showRelatedMajorsToggle = (mobile) => {
    return <div style={{ marginTop: '15px' }}>
      <label className="checkbox d-flex justify-content-between" style={{ cursor: 'pointer' }}>
        <div className={mobile ? 'd-flex flex-row' : ''}>
          <input
            type="checkbox"
            className='dca-checkbox'
            name="Show Related Majors"
            checked={showRelatedMajors}
            onChange={(event) => {
              handleClickActionsShowRelatedMajors(event)
            }}
            style={{ cursor: 'pointer' }}
          />
          <span className={mobile ? 'd-flex flex-row ms-3 me-3' : 'ms-3 me-3'} style={{ display: 'inline-block' }}>Show Related Majors <span className='ms-1'>{mobile ? <TooltipComponentMobile content={`Select the checkbox to also display majors that are similar to ${majorName}.`} /> : <TooltipComponent content={`Select the checkbox to also display majors that are similar to ${majorName}.`} />}</span></span>
        </div>
      </label>
    </div>
  }


  const [mobileFilterOpen, setMobileFilterOpen] = useState(false)

  const resetFilterStates = () => {
    setSelectedColleges([]);
    setSelectedSet([]);
    setKeywordSelect([])

    handleCollegeSelectChange([]);
    handleCollegeSetSelectChange([]);
  }

  const toggleFilterOpen = () => {
    setMobileFilterOpen(!mobileFilterOpen)
  }


  return mobile ? (
    <div className='dca-college-search-filter-drawer-container'>

      <button
        onClick={toggleFilterOpen}
        className={filtersActive > 0 ? 'dca-college-search-filters-button-bolded' : 'dca-college-search-filters-button'}><img src={filterIcon} alt="bars-filter" className="dca-college-filters-button-icon" />&nbsp;&nbsp;Filters {filtersActive > 0 && <span className='dca-filters-active-icon'>{filtersActive}</span>}</button>

      <div className={`dca-college-search-filter-drawer${mobileFilterOpen ? '-open' : ''}`} style={{ display: mobileFilterOpen ? 'flex' : 'none' }}>

        <div className='dca-college-search-mobile-filters-wrapper'>
          <div className='dca-college-search-filter-drawer-header'>
            <div className='dca-college-search-mobile-filters-title'>Filters</div>

            <div
              className="dca-college-search-filter-drawer-close-button"
              onClick={toggleFilterOpen}>
              &times;
            </div>
          </div>
          <div style={{ padding: '0px 15px 25px 15px', overflowY: 'auto' }}>
            {keywordSelectComponent}
            {collegeSelect}
            {/* Hide schoolTypeSelect while type field is not accessible */}
            {/* {schoolTypeSelect} */}
            {collegeSetSelect}
            {showRelatedMajorsToggle(true)}
          </div>

          <div className='dca-college-search-mobile-filters-drawer-footer'>
            <span className='dca-college-search-mobile-filters-drawer-footer-clear'
              onClick={() => {
                resetFilterStates()
              }}>Clear all</span>

            <button onClick={toggleFilterOpen} className='dca-college-search-mobile-filters-drawer-footer-view-results'>View Results</button>
          </div>
        </div>


      </div>
    </div>
  ) : (
    <div style={{ width: '260px', maxWidth: '260px', whiteSpace: 'nowrap' }}>
      {keywordSelectComponent}
      {collegeSelect}
      {/* Hide schoolTypeSelect while type field is not accessible */}
      {/* {schoolTypeSelect} */}
      {collegeSetSelect}
      {showRelatedMajorsToggle(false)}
    </div>
  )
}

export { Aside }
